import { RouteObject } from 'react-router-dom';
import HomePage from '@/pages/home/page';
import FlooringInstallationPage from '@/pages/flooring-installation/page';
import BathroomRemodelingPage from '@/pages/bathroom-remodeling/page';
import CommercialPage from '@/pages/commercial/page';
import ContactPage from '@/pages/contact/page';
import PortfolioPage from '@/pages/portfolio/page';
import NotFound from '@/pages/NotFound';

const routes: RouteObject[] = [
  { path: '/', element: <HomePage /> },
  { path: '/flooring-installation', element: <FlooringInstallationPage /> },
  { path: '/bathroom-remodeling', element: <BathroomRemodelingPage /> },
  { path: '/commercial', element: <CommercialPage /> },
  { path: '/portfolio', element: <PortfolioPage /> },
  { path: '/contact', element: <ContactPage /> },
  { path: '*', element: <NotFound /> },
];

export default routes;
